export const datadogConfig = {
  DD_CLIENT_TOKEN: 'puba369990f8ba193b6d9bc13eddf2cdd29',
  DD_SITE: 'datadoghq.com',
  DD_SERVICE: 'mikmak-dashboard',
  DD_FORWARD_ERRORS_TO_LOGS: true,
  DD_SAMPLE_RATE: 100,
};
